import CONSTANTS from './constants';

export const getCurrentApplication = (): string => {
  let application = localStorage.getItem(CONSTANTS.LOCAL_STORAGE_APPLICATION_ID);
  if (!application || application === CONSTANTS.UNKNOWN_APPLICATION) {
    application = 'enterprise';
  }
  return application;
};
